module.exports = __webpack_public_path__ + "static/media/groupmuseLogo.7f4962b3.jpg";